<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 16:42:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-08 18:46:31
-->
<template>
  <div>
    <p class="fz-14 yx-color-text-primary yx-pingfang-semibold verti-text-bottom"><span class="fz-28 verti-text-bottom">{{row.product_num}}</span>件</p>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin]
}
</script>